import { FC, PropsWithChildren, cloneElement } from 'react';

import { styled } from '../../theme';
import Collapse from '../Collapse';
import { useAccordion } from './AccordionGroup';

const AccordionWrapper = styled('div')<{ backgroundColor?: string; isOpen: boolean }>(
    ({ isOpen, backgroundColor }) => ({
        background: 'transparent',
        boxShadow: 'none',
        transition: 'all 0.3s ease',

        ...(isOpen && {
            margin: 'auto',
            background: backgroundColor || 'transparent',
        }),
    })
);

type Props = PropsWithChildren & {
    backgroundColor?: string;
    id: string;
};

const Accordion: FC<Props> = ({ children, backgroundColor, id }) => {
    const { openedState } = useAccordion();
    const isOpen = openedState.has(id);
    const [summary, details] = children?.map((child) => cloneElement(child, { id }));

    return (
        <AccordionWrapper isOpen={isOpen} backgroundColor={backgroundColor}>
            {summary}
            <Collapse in={isOpen} timeout={300} unmountOnExit>
                {details}
            </Collapse>
        </AccordionWrapper>
    );
};

export default Accordion;
